import PubSub from "underpub-js";

var Search = function(options) {
  this.options = {
    $el: false,
    baseClass: 'atom-Search'
  };

  $.extend(true, this.options, options);
};

Search.prototype.init = function() {
  this.isExpandable = this.options.$el.hasClass(this.options.baseClass + '--expandable');
  this.expandedClass = this.options.baseClass + '--expanded';

  this.$form = this.options.$el.find('.' + this.options.baseClass + '__form');
  this.$input = this.options.$el.find('.' + this.options.baseClass + '__input');
  this.$button = this.options.$el.find('.' + this.options.baseClass + '__icon');

  this.isExpanded = !this.isExpandable;

  if (this.isExpandable) {
    this.registerEventHandlers();
  }
};

Search.prototype.registerEventHandlers = function() {
  var self = this;

  this.$button.on('click', function(e) {
    if (!self.isExpanded) {
      e.preventDefault();
      self.expandSearch();
    } else if (self.$input.val().trim() === '') {
      e.preventDefault();
      self.collapseSearch();
    }
  });

  $(document).on('click', function(e) {
    if (self.isExpanded && !$(e.target).closest(self.options.$el).length) {
      self.collapseSearch();
    }
  });

  this.$button.on('mousedown', function(e) {
    e.stopPropagation();
  });

  this.$input.on('keydown', function(e) {
    if (e.key === 'Escape') {
      self.collapseSearch();
      self.$button.trigger('focus');
    }
  });
};

Search.prototype.expandSearch = function(shouldFocus) {
  if (shouldFocus === undefined) {
    shouldFocus = true;
  }

  this.options.$el.addClass(this.expandedClass);
  this.isExpanded = true;

  if (shouldFocus) {
    var self = this;
    setTimeout(function() {
      var value = self.$input.val();
      self.$input.trigger('focus')[0].setSelectionRange(value.length, value.length);
    }, 50);
  }
};

Search.prototype.collapseSearch = function() {
  this.options.$el.removeClass(this.expandedClass);
  this.isExpanded = false;
  this.$input.val('');
};

export default Search;
